<template>
  <div>
    <!-- <div class="mainTitle">学员管理</div> -->

    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth1">
        <el-row :gutter="20">
          <!-- <el-col :sm="24" :md="12" :lg="7">
            <el-form-item label="是否留电" prop="hasMobile">
              <el-select v-model="searchForm.hasMobile" clearable placeholder="请选择是否留电">
                <el-option
                  v-for="item in saveMobleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="7">
            <el-form-item label="同步分配" prop="sync">
              <el-select v-model="searchForm.sync" clearable placeholder="请选择同步分配">
                <el-option
                  v-for="item in isAllocationList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="10">
            <el-form-item label="留电时间" prop="mobileTime">
              <el-date-picker
                v-model="searchForm.mobileTime"
                format="yyyy-MM-dd"
                type="daterange"
                value-format="yyyy-MM-dd"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="所属机构" prop="agentId">
              <el-select style="width:100%" v-model="searchForm.agentId" clearable>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="姓名号码" prop="name">
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder="请输入姓名/号码"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="注册来源" prop="fromType">
              <el-select clearable v-model="searchForm.fromType" placeholder="请输入来源">
                <el-option
                  v-for="item in options"
                  :key="item.key"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="注册时间" prop="createTime">
              <el-date-picker
                style="width:100%"
                v-model="searchForm.createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="24" :md="12" :lg="24">
            <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>-->
          <el-col style="float:right" :sm="24" :md="12" :lg="12">
            <div class="button-Arrays" style="float:right">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="pageList"
                style="border-top-left-radius:3px !important;border-bottom-left-radius:3px !important;"
              >查询</el-button>
              <el-button
                type="primary"
                style="background:rgb(24,200,168);border-color:rgb(24,200,168)"
                icon="el-icon-refresh"
                @click="reset"
              >重置</el-button>
              <!-- icon="el-icon-search" -->
              <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
              <!-- icon="el-icon-plus" -->
              <!-- <el-button
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                style="background:rgb(251,149,82);border-color:rgb(251,149,82)"
              >导入</el-button>-->
              <!-- icon="el-icon-download" -->
              <!-- <el-button type="danger" @click="batchDeleteStudent" icon="el-icon-minus">批量删除</el-button> -->

              <!-- <el-button
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                icon="el-icon-upload2"
                :loading="loading"
              >导出</el-button>-->
              <!-- icon="el-icon-upload2" -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <!-- <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
          <el-button type="danger" @click="batchDeleteStudent" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style=" width: 100%;"
        border
        v-loading="studentLoading"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="agentName" label="机构名称"></el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="name" label="学生姓名"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="fromType" label="来源"></el-table-column>
        <el-table-column prop="registerIp" label="注册ip"></el-table-column>
        <!-- <el-table-column prop="sync" label="是否同步">
          <template slot-scope="scope">
            <span v-if="scope.row.sync==1">已同步</span>
            <span v-else>未同步</span>
          </template>
        </el-table-column>-->
        <el-table-column prop label="操作" width="220" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>
              <i
                class="iconfont iconchakan mainColor"
                title="查看"
                @click="selection = scope.row.id, viewFormVisible = true"
              ></i>
              <!-- <i
                class="iconfont iconjilu mainColor"
                title="开课记录"
                @click="getStudentBuyGoodsList(scope.row.id)"
              ></i>
              <i
                class="iconfont iconzhongzhi mainColor"
                title="重置密码"
                @click="resetStudentPassword(scope.row.id)"
              ></i>-->
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteStudent(scope.row)">删除</span>-->
              <!-- <span @click="selection = scope.row.id, viewFormVisible = true">查看</span> -->
              <span @click="getStudentBuyGoodsList(scope.row.id)">开课记录</span>
              <span @click="resetStudentPassword(scope.row.id)">重置密码</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加学员" :visible.sync="addFormVisible" width="600px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="学员手机" prop="mobile">
            <el-input
              clearable
              v-model="addForm.mobile"
              placeholder="请输入手机号码"
              auto-complete="off"
              maxlength="11"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="学员姓名" prop="name">
            <el-input
              clearable
              v-model="addForm.name"
              auto-complete="new-name"
              placeholder="请输入学生姓名"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="学员性别" prop="sex">
            <el-radio-group v-model="addForm.sex">
              <el-radio label>未知</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="-1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="登录密码" prop="password">
            <el-input
              clearable
              show-password
              v-model="addForm.password"
              placeholder="请输入密码"
              auto-complete="new-password"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="身份证号" prop="card">
            <el-input
              clearable
              v-model="addForm.card"
              placeholder="请输入身份证"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="电子邮箱" prop="email">
            <el-input
              clearable
              v-model="addForm.email"
              placeholder="请输入电子邮箱"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="联系地址" prop="address">
            <el-input
              clearable
              v-model="addForm.address"
              placeholder="请输入联系地址"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="备注说明" prop="remark">
            <el-input
              clearable
              type="textarea"
              :rows="3"
              v-model="addForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudent">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑学员" :visible.sync="editFormVisible" width="600px" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="手机号码" prop="mobile">
            <el-input
              clearable
              v-model="editForm.mobile"
              placeholder="请输入手机号码"
              auto-complete="off"
              maxlength="11"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="学生姓名" prop="name">
            <el-input
              clearable
              v-model="editForm.name"
              placeholder="请输入学生姓名"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="editForm.sex">
              <el-radio label>未知</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="-1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="密码" prop="password">
            <el-input
              disabled
              clearable
              show-password
              v-model="editForm.password"
              placeholder="请输入密码"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="身份证" prop="card">
            <el-input
              clearable
              v-model="editForm.card"
              placeholder="请输入身份证"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12">
          <el-form-item label="邮箱" prop="email">
            <el-input
              clearable
              v-model="editForm.email"
              placeholder="请输入邮箱"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="联系地址" prop="address">
            <el-input
              clearable
              v-model="editForm.address"
              placeholder="请输入联系地址"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              clearable
              type="textarea"
              :rows="3"
              v-model="editForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStudent">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看学员信息" :visible.sync="viewFormVisible" width="600px" left>
      <el-form ref="addForm" :model="editForm" :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="学员手机：" prop="mobile">
              <span>{{editForm.mobile}}</span>
              <!-- <el-input clearable
              v-model="editForm.mobile"
              placeholder="请输入手机号码"
              auto-complete="off"
              maxlength="11"
              ></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="学员姓名：" prop="name">
              <span>{{editForm.name}}</span>
              <!-- <el-input clearable
              v-model="editForm.name"
              placeholder="请输入学生姓名"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="12">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="学员性别：" prop="sex">
              <span>{{editForm.sex==''?"未知":editForm.sex==1?"男":"女"}}</span>
              <!-- 
            <el-radio-group v-model="editForm.sex">
              <el-radio label>未知</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="-1">女</el-radio>
              </el-radio-group>-->
            </el-form-item>
          </el-col>

          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="登录密码：" prop="password">
              <span>********</span>

              <!-- <el-input clearable
              v-model="editForm.password"
              placeholder="请输入密码"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="身份证号：" prop="card">
              <span>{{editForm.card}}</span>
              <!-- 
            <el-input clearable
              v-model="editForm.card"
              placeholder="请输入身份证"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>

          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="电子邮箱：" prop="email">
              <span>{{editForm.email}}</span>

              <!-- <el-input clearable
              v-model="editForm.email"
              placeholder="请输入邮箱"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="联系地址：" prop="address">
              <span>{{editForm.address}}</span>
              <!-- <el-input clearable
              v-model="editForm.address"
              placeholder="请输入联系地址"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="备注说明：" prop="remark">
              <span>{{editForm.remark}}</span>
              <!-- <el-input clearable
              type="textarea"
              :rows="3"
              v-model="editForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
              ></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="viewFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="viewFormVisible = false">确 定</el-button>
      </div>-->
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="name" label="学生姓名"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="fromType" label="来源"></el-table-column>
        <el-table-column prop="registerIp" label="注册ip"></el-table-column>
        <el-table-column prop="sync" label="是否同步"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
    <el-dialog title="开课记录" :visible.sync="goodsInfoFormVisible" width="600px" left>
      <el-table
        ref="multipleTable"
        :data="goodsInfoPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
        v-loading="loading"
      >
        <el-table-column prop="name" label="商品" width="280">
          <template slot-scope="row">
            <div style="display:flex">
              <img width="120" height="80" :src="row.row.logo?row.row.logo:''" />
              <div style="margin-left:10px">
                <span style="color:rgb(106,224,105)" v-if="row.row.recommend=='1'">{{"[推荐]"}}</span>
                <span style="color:rgb(106,224,105)" v-if="row.row.hot=='1'">{{"[热门]"}}</span>
                <span style="color:rgb(77,145,225)">{{row.row.name}}</span>
                <span style="display:block">
                  <span style="color:red">￥{{row.row.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{row.row.originalPrice}}</span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="开通价">
          <template slot-scope="row">
            <span>{{row.row.price}}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="validDay" label="开通时间">
          <template slot-scope="row">{{row.row.serviceBeginDate}}</template>
        </el-table-column>
        <el-table-column prop="postponeDay" label="结束时间">
          <template slot-scope="row">{{row.row.serviceEndDate==""?"-":row.row.serviceEndDate}}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      organizations: [],
      isAllocationList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "已留电",
          value: "1"
        },
        {
          label: "未留电",
          value: "-1"
        }
      ],
      saveMobleList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "已同步",
          value: "1"
        },
        {
          label: "未同步",
          value: "-1"
        }
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      goodsInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      goodsInfoFormVisible: false,
      viewFormVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      searchForm: {
        name: "",
        mobile: "",
        fromType: "",
        createTime: [],
        mobileTime: "",
        hasMobile: "",
        sync: ""
      },
      addForm: {
        mobile: "",
        name: "",
        sex: "",
        password: "",
        card: "",
        email: "",
        address: "",
        remark: ""
      },
      addFormRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字"
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确"
          }
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字"
          }
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确"
          }
        ],
        sex: [],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字"
          }
        ]
      },
      editForm: {
        mobile: "",
        name: "",
        sex: "",
        password: "",
        card: "",
        email: "",
        address: "",
        remark: ""
      },
      editFormRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字"
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确"
          }
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字"
          }
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确"
          }
        ],
        sex: [],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth1: "60px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      loading: false,
      studentLoading: true
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getStudentFromTypeList() {
      this.api.student
        .getStudentFromTypeList({})
        .then(result => {
          this.options = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAgentInfoList() {
      this.api.agentUserInfo.getAgentInfoList().then(result => {
        this.organizations = result.data;
      });
    },
    getStudent() {
      this.api.student
        .getStudent({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.student
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.studentLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addStudent() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.student
            .addStudent(this.addForm)
            .then(result => {
              if (result.success) {
                this.addFormVisible = false;
                this.$message({
                  type: "success",
                  message: result.message
                });
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateStudent() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.student
            .updateStudent(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    getStudentBuyGoodsList(row) {
      this.api.goodsInfo.getStudentBuyGoodsList({ id: row }).then(result => {
        if (result.success) {
          this.goodsInfoPage.rows = result.data;
          this.goodsInfoFormVisible = true;
        }
      });
    },
    resetStudentPassword(row) {
      this.$confirm("您确定要进行重置密码操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.student.resetStrudentPassword({ id: row }).then(result => {
            if (result.success) {
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          });
        })
        .catch(() => {});
    },
    deleteStudent(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.student
            .deleteStudent([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteStudent() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.student
        .exportExcel(this.searchForm)
        .then(result => {
          if (result.success) {
            location.href = result.data;
            this.loading = false;
          } else {
            this.$message.error(result.message);
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.student
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    "searchForm.createTime": function(newVal) {
      if (newVal) {
        this.searchForm.createTimeStart = newVal[0];
        this.searchForm.createTimeEnd = newVal[1];
      }
    },
    "searchForm.mobileTime": function(newVal) {
      if (newVal.length == 2) {
        this.searchForm.mobileTimeStart = newVal[0];
        this.searchForm.mobileTimeEnd = newVal[1];
      }
    },
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    viewFormVisible: function(newVal) {
      if (!newVal) {
        // this.$refs.editForm.resetFields();
        // this.pageList();
      } else {
        this.getStudent();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getAgentInfoList();
    this.getStudentFromTypeList();
  }
};
</script>
<style lang="less" scoped>
.el-select {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/student/index.vue